import React from 'react'
import { NavLink } from 'react-router-dom'
import { Option, toRelativeUrl, decodeHTMLEntities } from '../../../helpers'
import { PublicSiteState } from '../../public_site.main.mod'
import { WordPress, withDataState } from '../../wordpress/wordpress_api'

type Props = {
  location: 'main'
  hasActiveState: boolean
  s0: PublicSiteState
}

type State = withDataState<WordPress.MenuLocationResponse>

export default class MainNavItems extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      kind: 'loading'
    }
  }

  componentDidMount() {
    WordPress.findMenuByLocation(this.props.location)
      .then(response => this.setState(s => ({ ...s, kind: 'loaded', data: Option(response.data) })))
      .catch(() => this.setState({ kind: 'error' }))
  }

  render() {
    return (
      this.state.kind === 'loaded' &&
      this.state.data.kind === 'some' && (
        <>
          <ul className='menu__list typo--l'>
            {this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) => (
              <li className="menu__item" key={`menu-${this.props.location}-${index}`}>
                {this.navItem(menuItem)}
              </li>
            ))}
          </ul>
        </>
      )
    )
  }

  navItem(menuItem: WordPress.MenuItem) {
    return menuItem.type == 'custom' || this.props.s0.Fc150YearsMainPage.current_page == '404' ? (
      <a className="menu__link" href={this.props.s0.Fc150YearsMainPage.current_page == '404' ? toRelativeUrl(menuItem.url) : menuItem.url} target={menuItem.target} rel={menuItem.target == '_blank' ? 'noopener' : null}>
        {decodeHTMLEntities(menuItem.title)}
      </a>
    ) : (
      <NavLink className="menu__link" to={toRelativeUrl(menuItem.url)} activeClassName={this.props.hasActiveState ? 'active' : null}>
        {decodeHTMLEntities(menuItem.title)}
      </NavLink>
    )
  }
}
